"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationManufacturingInfo = void 0;
const common_1 = require("../../common");
const models_1 = require("../../setup/models");
const product_model_1 = require("./product.model");
class LocationManufacturingInfo extends common_1.MongoDocument {
}
exports.LocationManufacturingInfo = LocationManufacturingInfo;
//# sourceMappingURL=location-manufacturing-info.model.js.map